module.exports = __webpack_public_path__ + "img/warring.089f68fe.png";